export const LOG_LEVEL = {
  DEBUG: 10,
  INFO: 20,
  WARN: 30,
  ERROR: 40,
} as const;

export type LogLevel = (typeof LOG_LEVEL)[keyof typeof LOG_LEVEL];

export const DEFAULT_LOG_LEVEL = LOG_LEVEL.WARN;
export const PDF_WORKER_SRC = '/pdf.worker.min.mjs';
